import Model, { ID, IsoDateTime, JsonObject, MODEL_LEVEL } from 'src/models/model'

export default class CustomerioSegmentTaskAction extends Model {
  static name = 'CustomerioSegmentTaskAction'

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing]

  static paginate = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true,
        output: true
      },
      state: {
        type: String,
        required: true,
        output: true
      },
      actionArguments: {
        type: JsonObject,
        required: true,
        default: () => ({})
      },
      actionResults: {
        type: JsonObject,
        output: true
      },
      startedAt: {
        type: IsoDateTime,
        output: true
      },
      completedAt: {
        type: IsoDateTime,
        output: true
      },
      erroredAt: {
        type: IsoDateTime,
        output: true
      },
      errorMessage: {
        type: String,
        required: false,
        output: true
      },
      createdAt: {
        type: IsoDateTime,
        output: true
      },
      updatedAt: {
        type: IsoDateTime,
        output: true
      }
    }
  }
}
